import React from 'react';

const Wrapper = ({ children }) => (
  <div className="mocana-wrapper">{children}</div>
);

export default Wrapper;
